var t=function(){var t={};return{defaults:function(r,n){t=n},get:function(r,n){var u=r();return void 0!==u?u:t[n]}}};export{t as __moduleExports,t as default};
//# sourceMappingURL=defaults.js.map
